import React, { Component } from 'react';
import { Segment, Label } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';

class FormFooter extends Component {
  render() {
    const { isLoading } = this.props;
    const errorLabel = <Label color="red" pointing basic />;

    return (
      <Segment basic textAlign="center">
        <Form.Checkbox
          name="confirm"
          label={
            <label>
              Jeg aksepterer herved HANENs{' '}
              <a
                href="https://drive.google.com/file/d/1P8L-PA3XucDRQ5NdC0v3pix_Nq77nAfb/view"
                target="_blank"
                rel="noopener noreferrer"
              >
                vedtekter
              </a>{' '}
              og{' '}
              <a
                href="https://drive.google.com/file/d/1MpXPfb0WKBgAsZetXOGVMHKujZTxtXjB/view"
                target="_blank"
                rel="noopener noreferrer"
              >
                verdigrunnlag
              </a>
              .
            </label>
          }
          required
          validations="isTrue"
          validationErrors={{
            isTrue:
              'Du må godkjenne vedtekene og verdigrunnlaget for å kunne bli medlem.',
            isDefaultRequiredValue:
              'Du må godkjenne vedtekene og verdigrunnlaget for å kunne bli medlem.',
          }}
          errorLabel={errorLabel}
        />
        <Form.Button
          color="yellow"
          size="big"
          loading={isLoading}
          disabled={isLoading}
        >
          Ja, jeg ønsker å bli medlem av HANEN
        </Form.Button>
      </Segment>
    );
  }
}

export default FormFooter;



// WEBPACK FOOTER //
// ./src/Form/FormFooter.js